export default {
  validateLowCase: function(rule, value, callback) {
    let res = /[a-z]+/g;
    if (res.test(value)) {
      callback();
    } else {
      callback(new Error("必须包含小写字母"));
    }
  },
  validateCaptalCase: function(rule, value, callback) {
    let res = /[A-Z]+/g;
    if (res.test(value)) {
      callback();
    } else {
      callback(new Error("必须包含大写字母"));
    }
  },
  validateNumberCase: function(rule, value, callback) {
    let res = /\d/;
    if (res.test(value)) {
      callback();
    } else {
      callback(new Error("必须包含数字"));
    }
  },
  validateSymbolCase: function(rule, value, callback) {
    let res = /[`~!@#$%^&*()_\-+=<>?:"{}|,.'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/g;
    if (res.test(value)) {
      callback();
    } else {
      callback(new Error("必须包含特殊字符"));
    }
  },
  handerRuleSet: function(rule, ruleData) {
    // 密码长度修改
    if (rule.minLength) {
      ruleData.newPassword.push({
        min: rule.minLength,
        message: `密码必须大于${rule.minLength}位`,
        trigger: "blur"
      });
    }
    if (rule.isCapital) {
      ruleData.newPassword.push({
        trigger: "blur",
        validator: this.validateCaptalCase,
        message: "必须包含大写字母"
      });
    }
    if (rule.isLower) {
      ruleData.newPassword.push({
        trigger: "blur",
        validator: this.validateLowCase,
        message: "必须包含小写字母"
      });
    }

    if (rule.isNumber) {
      ruleData.newPassword.push({
        trigger: "blur",
        validator: this.validateNumberCase,
        message: "必须包含数字"
      });
    }
    if (rule.isSymbol) {
      ruleData.newPassword.push({
        trigger: "blur",
        validator: this.validateSymbolCase,
        message: "必须包含特殊字符"
      });
    }
  },
  handerItemRule: function(rule, item) {
    // 密码长度修改
    
    if (!item.rules) {
      item.rules = [];
    }
    if (item.addRule) {
      return false;
    }
    if (rule.minLength) {
      item.rules.push({
        min: rule.minLength,
        message: `密码必须大于${rule.minLength}位`,
        trigger: "blur"
      });
    }
    if (rule.isCapital) {
      item.rules.push({
        trigger: "blur",
        validator: this.validateCaptalCase,
        message: "必须包含大写字母"
      });
    }
    if (rule.isLower) {
      item.rules.push({
        trigger: "blur",
        validator: this.validateLowCase,
        message: "必须包含小写字母"
      });
    }

    if (rule.isNumber) {
      item.rules.push({
        trigger: "blur",
        validator: this.validateNumberCase,
        message: "必须包含数字"
      });
    }
    if (rule.isSymbol) {
      item.rules.push({
        trigger: "blur",
        validator: this.validateSymbolCase,
        message: "必须包含特殊字符"
      });
    }
  }
};
